<template>
    <div class="mob_login_bgd">
        <div class="mob_header">
            <div class="mob_login" >
                <img src="../../assets/home2.png" alt="" >
            </div>
            <div style="position: absolute;bottom:-14px;left:50%;transform: translateX(-50%)">
                <i class="fa fa-caret-up fa-3x" style="color: #FFFFFF"></i>
            </div>
        </div>
        <div class="mob_form">
            <div class="mob_content">
                <div><input type="text" style="background:#f5f5f5 " id="loginName" v-model="loginForm.name" placeholder="賬號"></div>
            </div>
            <div class="mob_content">
                <div><input type="password" style="background:#f5f5f5 " v-model="loginForm.password" id="password" placeholder="密碼"></div>
            </div>
            <div class="mob_content mob_code_contet" >
                <div ><input type="text" id="code" style="background:#f5f5f5 " v-model="loginForm.code" placeholder="驗證碼"></div>
                <div style="width:20%"><el-button :style="{'color':codeCount>=60?'':'gray','cursor':codeCount>=60?'pointer':'not-allowed'}" class="code_btn"  @click="validCodeSend()" >{{codeMsg}}</el-button></div>
            </div>
            <div style="padding:40px 0px">
                <el-button  class="enter_btn"  @click="handleSubmit()"  :style="{'background':loading?'rgb(180 208 218)':'rgb(68 181 224)'}"> <i class="fa fa-spinner fa-spin fa-x fa-fw" v-if="loading"></i>登入</el-button>
            </div>
        </div>
        <div>
            <transition name="fade">
                <div style="position: fixed;left:0px;right:0px;top:0px;bottom:0px;background:rgba(3,3,3,0.3);"  v-if="alrShow">
                    <div style="position: fixed;left:10px;right:15px;top:40px;bottom:50px;background:#FFFFFF;overflow: auto;padding:20px 20px;border-radius: 52px;" v-if="alrShow">
                        <p style="text-align: center">{{title}}</p>
                        <div v-html="msg" style="text-align: center">
                        </div>
                        <p style="text-align:center;padding: 10px">
                            <el-button type="default" @click="cancel()"style="width:45%">取消</el-button>  <el-button type="primary" @click="enter" style="width:45%">登入</el-button>
                        </p>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
    import {getToken,insertMsgCode,validMsgCode} from  '../../api/api'
    import router from '@/router/router'
    import parseMenu from '@/utils/MenuUtil'
    export default {
        name:'mobileLogin',
        data(){
          return{
              loading:false,
              title:'',
              alrShow:false,
              isLogin:false,
              options: [{
                  value: 'zh-CN',
                  label: '簡體'
              }, {
                  value: 'zh-TW',
                  label: '繁體'
              }, {
                  value: 'en-US',
                  label: 'English'
              }],
              langVal:"zh-CN",
              logining: false,
              loginForm: {
                  code:'',
                  name: "",
                  password: ""
              },
              msg:'',
              checked: true,
              codeCount:60,
              codeMsg:"發送驗證碼",
              codeDisabled:false,
              dialogName:"",
              privateContent:"",
              privateIndexOption:[
                  {label:'免責聲明及擁有權',value:1,content:"<p class=\"ql-align-center\">有關本網站的重要資訊</p><p><br></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">本網站由恒泰財資(「恒資」)所運作，此網站所有的資料僅作一般性參考，並不構成財務、醫療、投資或其他任何建議。恒資會合理地處理本網站所提供的資料，此等資料並不是為閣下的投資目標、財務狀況或特別需要而設。當本網站的資料有所更改時，恒資會在可行的情況下盡力更新有關資料。但由於資料可能在沒有通告的情況下更改，故恒資不會保證在所有情況下本網站資料的準確性，包括由第三者所提供的資料。此等資料是特別為香港居民而設並不適合於中國大陸境內使用，除非特別闡明，否則所有貨幣均以港幣計算。除非特別闡明，本網站內所提供的資料的版權由恒資所有。閣下不能以任何形式更改或修改這些資料，包括移除此版權通告。除法律不容許免除的責任外，若閣下因本網站的資料而導致任何損失、賠償、費用或其他開支，恒資不會承擔任何責任。</span></p>"},
                  {label:'個人資料政策',value:2,content:"<p>恒泰財資個人資料政策</p><p><br></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">恒泰財資(「恒資」) 一向重視個人私隱權，故此全力支持實施個人資料（私隱）條例。恒資的客戶、營業員及雇員，信賴本公司保障他們的個人私隱。對於他們的信賴，我們深感榮幸，並會依據下列原則，切實維護他們的私隱。&nbsp;</span></p><p><br></p><p><strong style=\"color: rgb(0, 0, 0);\">資料收集及使用</strong></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">我們只會收集有需要的資料，並會從公平的途徑去收集，及會披露一般的使用目的。</span></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">我們使用該等個人資料，是為了迎合我們客戶、營業員及雇員的需要及有關目的。我們會一直遵守法律，在未知會並得到有關人士同意之前，我們都不會使用該個人資料在其他用途。這是我們一直奉行的宗旨。</span></p><p><br></p><p><strong style=\"color: rgb(0, 0, 0);\">資料的質素</strong></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">我們深明個人資料的準確性之重要，並會採取所有切實可行的步驟，以確保該等個人資料之準確性。</span></p><p><br></p><p><strong style=\"color: rgb(0, 0, 0);\">保安</strong></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">我們嚴謹執行保安措施，以確保該等個人資料之機密性。只有為本公司工作的人士，在公事所需的情況下，方有權接觸該等個人資料。</span></p><p><br></p><p><strong style=\"color: rgb(0, 0, 0);\">回應要求</strong></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">對於有關查閱及更改個人資料的要求，我們會儘快作出回應。倘我們因遵從法律規定而拒絕有關要求，我們會作出解釋。</span></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">保障私隱是我們為客戶、營業員及雇員提供的服務之一。我們在保障私隱時，會維持最優質的服務水準，就如我們提供其他服務一樣。</span></p><p class=\"ql-align-right\">恒泰財資&nbsp;</p><p class=\"ql-align-right\">這項政策適用於恒泰保險財資服務有限公司屬下各公司</p><p><br></p>"},
                  {label:'安全性',value:3,content:"<p class=\"ql-align-center\">安全性</p><p><br></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">恒泰財資(「恒資」)承諾會確保閣下的私人資料保密。為確保資料的保密性，我們實行了以下的安全措施: 料的保密性，我們實行了以下的安全措施:&nbsp;</span></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">1. 我們會將資料儲存于一個安全網站，並使用128位加密技 術將資料加密保護, 而這個加密技術是市面上最安全的一種。 此外, 所有傳送至恒資及由恒資發出的資料都會經由 SSL (Secure Socket Layer) 安全通訊機制加密。 術將資料加密保護, 而這個加密技術是市面上最安全的一種。 此外, 所有傳送至恒泰及由恒泰發出的資料都會經由 SSL (Secure Socket Layer) 安全通訊機制加密。&nbsp;</span></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">2. 閣下可透過電子憑證(Electronic Certificate) 確認本網站是屬於恒泰保險財資服務有限公司所有。閣下可根據以下 資料核對: Certificate) 確認本網站是屬於恒泰保險財資服務有限公司所有。閣下可根據以下 資料核對:&nbsp;</span></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">資料核對:&nbsp;</span></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">Issued to = eversupport.eifs.com.hk:</span></p><p><span style=\"color: rgb(0, 0, 0);\">Issued by = GeoTrust Inc,</span></p>"},
              ],
              privateVisible:false,
              loginMsg:"<p class=\"ql-align-center\">有關本網站的重要資訊</p><p><br></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">本網站由恒泰財資(「恒資」)所運作，此網站所有的資料僅作一般性參考，並不構成財務、醫療、投資或其他任何建議。恒資會合理地處理本網站所提供的資料，此等資料並不是為閣下的投資目標、財務狀況或特別需要而設。當本網站的資料有所更改時，恒資會在可行的情況下盡力更新有關資料。但由於資料可能在沒有通告的情況下更改，故恒資不會保證在所有情況下本網站資料的準確性，包括由第三者所提供的資料。此等資料是特別為香港居民而設並不適合於中國大陸境內使用，除非特別闡明，否則所有貨幣均以港幣計算。除非特別闡明，本網站內所提供的資料的版權由恒資所有。閣下不能以任何形式更改或修改這些資料，包括移除此版權通告。除法律不容許免除的責任外，若閣下因本網站的資料而導致任何損失、賠償、費用或其他開支，恒資不會承擔任何責任。</span></p>",
              loginMsg2:"<p class=\"ql-align-center\">有關本網站的重要資訊</p><p><br></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">本網站由本公司所運作，此網站所有的資料僅作一般性參考，並不構成財務、醫療、投資或其他任何建議。本公司會合理地處理本網站所提供的資料，此等資料並不是為閣下的投資目標、財務狀況或特別需要而設。當本網站的資料有所更改時，本公司會在可行的情況下盡力更新有關資料。但由於資料可能在沒有通告的情況下更改，故本公司不會保證在所有情況下本網站資料的準確性，包括由第三者所提供的資料。此等資料是特別為香港居民而設並不適合於中國大陸境內使用，除非特別闡明，否則所有貨幣均以港幣計算。除非特別闡明，本網站內所提供的資料的版權由本公司所有。閣下不能以任何形式更改或修改這些資料，包括移除此版權通告。除法律不容許免除的責任外，若閣下因本網站的資料而導致任何損失、賠償、費用或其他開支，本公司不會承擔任何責任。</span></p>",
              loginTitle:"免責聲明及擁有權",
              isHkServer:"",
              systemCpy:"",
              rightStr:"本資料乃恒泰保險財資服務有限公司之資產，恒泰保險財資服務有限公司擁有本資料全部智慧財產權。"
          }
        },
        mounted() {
            //獲取cookie 記住用戶名細資訊
            this.getCookie();

            //獲取國際化語言
            this.getLangCoikieKey();

            var tags=document.getElementsByTagName("*");//獲取HTML的所有標籤
            for(var i in tags){//對標籤進行遍歷
                if(tags[i].nodeType==1){//判斷節點類型
                    if(tags[i].getAttribute("id") == "loginName")//判斷ID判斷控制項
                    {
                        tags[i].focus();
                        break;
                    }
                }
            }
            let hostName = window.document.location.hostname;
            if(hostName.indexOf("esupport")>=0 || hostName.indexOf('localhost')>=0 || hostName.indexOf('www.bigthertmr')>=0){
                this.isHkServer=true;
                this.$store.commit("updateIsHkServer");
                this.systemCpy=1;
                this.$store.commit("updateSystemCpy",this.systemCpy);
            }else if(hostName.indexOf("cpver3")>=0){
                this.isHkServer=false;
            }else if(hostName.indexOf("blueoak")>=0 || hostName.indexOf('bo.bigthertmr')>=0 || hostName.indexOf('system.blueoak.com.hk')>=0){
                this.isHkServer=true;
                this.$store.commit("updateIsHkServer");
                this.systemCpy=2;
                this.$store.commit("updateSystemCpy",this.systemCpy);
                this.rightStr = this.rightStr.replace(/恒泰保險財資服務有限公司/g,"宏泰國際");
                this.privateIndexOption.forEach((v,i)=>{
                    v.content=v.content.replace(/恒泰財資/g,"宏泰國際");
                    v.content=v.content.replace(/恒資/g,"宏泰");
                    v.content=v.content.replace(/恒泰保險財資服務有限公司/g,"宏泰國際");
                    v.content=v.content.replace(/恒泰/g,"宏泰國際");

                });
                //恒泰財資(「恒資」)
                this.loginMsg = this.loginMsg.replace(/恒泰財資/g,"宏泰國際");
                this.loginMsg = this.loginMsg.replace(/恒資/g,"宏泰");
            }
        },
        methods:{

            validIsLogin(){
                if(this.loginForm.code!=null && this.loginForm.code!=''
                    && this.loginForm.name!=null && this.loginForm.name!=''
                    && this.loginForm.password!=null && this.loginForm.password!=''){
                    this.isLogin=true;
                }else{
                    this.isLogin=false;
                }
            },
            goMail(){
                window.open("http://mail.eifs.com.hk/")
            },
            open(index2) {
                this.dialogName = this.privateIndexOption.find(v=>v.value==index2).label;
                this.privateContent = this.privateIndexOption.find(v=>v.value==index2).content;
                this.privateVisible = true;
            },
            cancel(){
            this.alrShow=false
            this.$toast({
            message: '已經取消登入',
            position: 'center',
            color:'red',
            duration: 5000
            });
            this.loading=false
            },
            //發送驗證碼
            validCodeSend(){
                if(this.codeCount==60){
                    insertMsgCode(this.loginForm.name).then(res=>{
                        if(res.errcode!=200){
                            this.$toast({
                                message: res.errmsg,
                                position: 'center',
                                color:'red',
                                duration: 5000
                            });
                        }
                    }).catch((error)=>{
                        console.log("insertMsgCode Error");
                    });
                }
                if (this.codeCount == 0) {
                    this.codeMsg = "發送驗證碼"
                    this.codeCount = 60;
                    return;
                } else {
                    this.codeMsg = "等待".concat(this.codeCount).concat("秒");
                    this.codeCount--;
                }
                if (this.codeCount >= 0) {
                    setTimeout(this.validCodeSend, 1000);
                }
            },
            handleReset() {
                this.$refs.loginForm.resetFields();
            },
            enter(){

                    window.sessionStorage.setItem("staff",JSON.stringify(this.staff));       //將使用者存儲在session中
                    this.loading=false
                    // let routes=[];
                    // parseMenu(routes,staff.menus);
                    // router.addRoutes(routes);
                    // this.$router.options.routes.push(...routes);
                    this.$store.commit("updateStaff",this.staff);
                    this.$router.push({ path:'/mobile/homePage' });

            },
            handleSubmit(ev) {
                if(this.loading){
                    return;
                }
                this.loading=true
                if(this.loginForm.name!=null && this.loginForm.name!=''
                    && this.loginForm.password!=null && this.loginForm.password!=''){
                }else {
                    this.$toast({
                        message: "賬號或秘密不能爲空",
                        position: 'center',
                        color:'red',
                        duration: 5000
                    });
                    this.loading=false
                    return
                }
                if (this.loginForm.code === '') {
                    this.$toast({
                        message: '驗證碼不能為空',
                        position: 'center',
                        color:'red',
                        duration: 5000
                    });
                    this.loading=false
                }else {
                    if(this.loginForm.code.length>=4){
                        var params ={nowDate: Math.round((new Date().getTime()/1000)*10000/10000),loginName:this.loginForm.name,code:this.loginForm.code};
                        validMsgCode(params).then(res=>{
                            if(res.errcode==200){
                                var params={name:this.loginForm.name,password:this.loginForm.password,isHkServer:this.isHkServer};
                                getToken(params).then(
                                    res2=>{
                                        //判斷核取方塊是否被勾選 勾選則調用配置cookie方法
                                        if(res2.errcode===200){
                                            let msg = this.loginMsg;
                                            if(this.systemCpy==1){
                                                msg = this.loginMsg2;
                                            }else if(this.systemCpy==2){
                                            }
                                            this.title= this.loginTitle
                                            this.msg=msg
                                            this.alrShow=true
                                            this.staff=res2.data
                                        }else{
                                            this.$toast({
                                                message: res2.errmsg,
                                                position: 'center',
                                                color:'red',
                                                duration: 5000
                                            });
                                        }
                                    },
                                    err=>{
                                        this.logining = false;
                                    }
                                );
                            }else{
                                this.$toast({
                                    message: "validMsgCode Error",
                                    position: 'center',
                                    color:'red',
                                    duration: 5000
                                });
                                this.loading=false
                            }
                        }).catch((error)=>{
                            this.$toast({
                                message: res.errmsg,
                                position: 'center',
                                color:'red',
                                duration: 5000
                            });
                            this.loading=false
                        });


                }}
            },
            //設置cookie
            setCookie(c_name,c_pwd,exdays) {
                var exdate=new Date();//獲取時間
                exdate.setTime(exdate.getTime() + 7*24* 60 * 60 * 1000);//保存的天數
                //字串拼接cookie
                window.document.cookie="userName"+ "=" +c_name+";path=/;expires="+exdate.toGMTString();
                //window.document.cookie="userPwd"+"="+c_pwd+";path=/;expires="+exdate.toGMTString();
            },
            //讀取cookie
            getCookie:function () {
                if (document.cookie.length>0) {
                    var arr=document.cookie.split('; ');//這裡顯示的格式需要切割一下自己可輸出看下
                    for(var i=0;i<arr.length;i++){
                        var arr2=arr[i].split('=');//再次切割
                        //判斷查找相對應的值
                        if(arr2[0]=='userName'){
                            this.loginForm.name=arr2[1];//保存到保存資料的地方
                            this.checked=true;
                        }else {
                            this.checked=false;
                        }
                        /*if(arr2[0]=='userPwd'){
                            this.loginForm.password=arr2[1];
                            this.checked=true;
                        }else {
                            this.checked=false;
                        }*/
                    }
                }
            },
            getLangCoikieKey(){
                if (document.cookie.length>0) {
                    var arr=document.cookie.split('; ');//這裡顯示的格式需要切割一下自己可輸出看下
                    for(var i=0;i<arr.length;i++){
                        var arr2=arr[i].split('=');//再次切割
                        //判斷查找相對應的值
                        if(arr2[0]=='langKey'){
                            this.langVal=arr2[1];
                            this.$i18n.locale = arr2[1];//關鍵語句
                        }
                    }
                }
            },
            //清除cookie
            clearCookie:function () {
                this.setCookie("","",-1);//修改2值都為空，天數為負1天就好了
            },
            /**
             * 切換語言
             */
            changeLangEvent(val) {
                this.$i18n.locale = val;//關鍵語句
                var exdate=new Date();//獲取時間
                exdate.setTime(exdate.getTime() + 24*60*60*1000*7);//保存的天數
                window.document.cookie="langKey"+"="+val+";path=/;expires="+exdate.toGMTString();
                this.$refs.loginForm.validate((valid) => {});
            }
        }
    }
</script>
<style scoped>
    .mob_login{
        width:90px;
        height:90px;
        background: #FFFFFF;
        border-radius:50%;
        line-height:100px;
        text-align: center;
        position: absolute;
        left:50%;
        transform: translateX(-50%);
        bottom:20px;
    }
    .mob_code_contet div:nth-child(1){
        width:58%;
        display: inline-block;
    }
    .mob_code_contet div:nth-child(2){
        width:40%;
        display: inline-block;
    }
    .code_btn{
        color: #FFF;
        background-color:rgb(68 181 224);
        height: 44px;
        line-height: 0px;
        width: 198%;
    }
    #loginName,#password{
        border:1px solid #dadada !important;
        padding:0px 0px 0px 10px!important;
        height: 42px!important;
        font-size: 15px;
        width:100% !important;
    }
    #code{
        border:1px solid #dadada !important;
        padding:0px 0px 0px 10px!important;
        height: 42px!important;
        font-size: 15px;
        width:100% !important;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .mob_content{
        padding: 10px 0px 5px ;
    }
    .mob_content div:nth-child(2){
        display: inline-block;
        width:90%;
        text-align: left;
    }
    .mob_login_bgd{
        width: 100%;
        height: 100%;
        background-color: #FFFFFF;
        position: fixed;
    }
    .mob_header{
        position: relative;
        height:200px;
        background: #44b5e0;
    }
    .pass_content i{
        color: #94c93d;
    }
    .pass_content{
        padding: 0px 35px;
        width:90%;
        height:300px;
        background: #FFFFFF;
        position: absolute;
        top:250px;
        left:50%;
        transform: translateX(-50%);
        border-radius:35px;
        text-align: center
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        -webkit-transition-delay: 111111s;
        -webkit-transition: color 11111s ease-out, background-color 111111s ease-out;
    }
    .mob_form{
        padding:15px 35px;
    }
    .enter_btn{
        width:100%;
        color: #FFFFFF
    }
</style>



// WEBPACK FOOTER //
// src/views/mobile/mobileLogin.vue